import { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { PageHeader, Panel, StatusPill, EmptyState } from "../../components/Bits";
import { api } from "../../lib/api";
import { Download } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function StudentFees() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/fees/me").then((r) => setRows(r.data)); }, []);

  const total = (rows || []).reduce((a, b) => a + (b.status === "paid" ? Number(b.amount) : 0), 0);
  const pending = (rows || []).reduce((a, b) => a + (b.status !== "paid" ? Number(b.amount) : 0), 0);

  return (
    <AppShell>
      <PageHeader overline="My payments" title="Fee history" subtitle="Your payment records and downloadable receipts." />
      <div className="grid sm:grid-cols-2 gap-4 mb-8">
        <div className="bg-white border border-warm rounded-lg p-5">
          <div className="text-xs uppercase tracking-wider text-warm">Paid till date</div>
          <div className="font-body font-semibold text-3xl text-deep tracking-tight mt-2">₹ {total.toLocaleString()}</div>
        </div>
        <div className="bg-white border border-warm rounded-lg p-5">
          <div className="text-xs uppercase tracking-wider text-warm">Pending</div>
          <div className="font-body font-semibold text-3xl text-deep tracking-tight mt-2">₹ {pending.toLocaleString()}</div>
        </div>
      </div>

      <Panel>
        {rows === null ? <div className="text-sm text-warm">Loading…</div>
          : rows.length === 0 ? <EmptyState title="No records yet" hint="Once your warden records a payment, it'll appear here." />
            : (
              <div className="overflow-x-auto -mx-6">
                <table className="min-w-full text-sm">
                  <thead><tr className="bg-[#F4F1EA] text-warm uppercase tracking-wider text-xs">
                    <th className="text-left px-6 py-3">Receipt</th>
                    <th className="text-left px-6 py-3">Month</th>
                    <th className="text-left px-6 py-3">Amount</th>
                    <th className="text-left px-6 py-3">Method</th>
                    <th className="text-left px-6 py-3">Status</th>
                    <th className="text-right px-6 py-3">Receipt</th>
                  </tr></thead>
                  <tbody>
                    {rows.map((f) => (
                      <tr key={f.id} className="border-t border-warm hover:bg-[#FDFBF7]">
                        <td className="px-6 py-3 font-mono text-xs">{f.receipt_no}</td>
                        <td className="px-6 py-3">{f.month}</td>
                        <td className="px-6 py-3 font-medium">₹ {Number(f.amount).toLocaleString()}</td>
                        <td className="px-6 py-3 capitalize">{f.method || "—"}</td>
                        <td className="px-6 py-3"><StatusPill status={f.status} /></td>
                        <td className="px-6 py-3 text-right">
                          {f.status === "paid" && (
                            <a href={`${BACKEND_URL}/api/fees/${f.id}/receipt`} target="_blank" rel="noreferrer" data-testid={`download-${f.id}`} className="inline-flex items-center gap-1 text-sm text-[#C86F58] hover:underline">
                              <Download className="h-4 w-4" /> PDF
                            </a>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
      </Panel>
    </AppShell>
  );
}
